<app-main-navigation></app-main-navigation>
<app-price-robot-submenu></app-price-robot-submenu>
<div class="container-fluid pb-1" *ngIf="products != null && variantGroups != null && users != null; else spinner"
     [ngClass]="{faded:loading}">

    <app-price-robot-filter-box (refresh)="refresh($event)"
                                [filter]="filter"
                                [users]="users"
                                (updatedFilter)="overwriteFilter($event)"
                                [categories]="categories"
                                [variantGroups]="variantGroups" [page]="'products'"></app-price-robot-filter-box>

    <div class="h2 text-center mt-4 me-5" *ngIf="loading === false && products.length < 1">
        Der er ingen produkter der matcher din søgning
        <br>
        <button class="btn btn-primary" (click)="resetSearch()"> Nulstil søgning</button>
    </div>
    <button class="btn btn-outline-primary ms-4 mt-2" (click)="openModal(content)">
        Price graphs
    </button>
    <ng-template #content let-modal>
        <div class="modal-header" [ngClass]="{faded:loading}">
            <h4 class="modal-title">Price graphs</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" [ngClass]="{faded:loading}">
            <app-price-graphs [filter]="filter"></app-price-graphs>
        </div>
    </ng-template>
    <ng-container *ngIf="loading === false; else spinner">

        <table class="table table-striped align-middle mt-4 table-sm">
            <ng-template #none>
                <p style="color: grey;">
                    Ingen
                </p>
            </ng-template>
            <tr app-price-robot-product-header [filter]="filter" (doRefresh)="refresh($event.number, $event.sort, $event.direction)"></tr>
            <tbody>
            <ng-template ngFor let-product [ngForOf]="products" let-i="index">
                <tr app-price-robot-product-row [product]="product"></tr>
            </ng-template>
            </tbody>
        </table>

        <ngb-pagination
                [(page)]="pageNr"
                [pageSize]="20"
                [maxSize]="20"
                [collectionSize]="meta.count">
            <ng-template ngbPaginationPages let-page let-pages="pages" let-disabled="disabled">
                <li *ngFor="let pageNumber of pages" class="page-item" [class.active]="pageNumber === page"
                    [class.disabled]="pageNumber === -1 || disabled" [attr.aria-current]="(pageNumber === page ? 'page' : null)">
                    <a *ngIf="pageNumber === -1" class="page-link" tabindex="-1" aria-disabled="true">
                        ...
                    </a>
                    <a *ngIf="pageNumber !== -1" class="page-link"
                       [routerLink]="[]"
                       [queryParams]="{page:pageNumber}" [preserveFragment]="true" [queryParamsHandling]="'merge'"
                       [attr.tabindex]="disabled ? '-1' : null" [attr.aria-disabled]="disabled ? 'true' : null">
                        {{pageNumber}}
                    </a>
                </li>
            </ng-template>
        </ngb-pagination>

    </ng-container>
</div>


<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
